import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { SplitMenuButtonWebElement } from './SplitMenuButtonWebElement';
export { SplitMenuButtonWebElement };

/**
 * Retrieve an instance of [SplitMenuButtonWebElement](../classes/SplitMenuButtonWebElement.html).
 * @example
 * ```javascript
 * import { findSplitMenuButton } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findSplitMenuButton(driver, By.id('my-oj-c-split-menu-button'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findSplitMenuButton(
  driver: DriverLike,
  by: By
): Promise<SplitMenuButtonWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type SplitMenuButtonWebElement
  if (!(webEl instanceof SplitMenuButtonWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'SplitMenuButtonWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findSplitMenuButton(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${SplitMenuButtonWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-split-menu-button', SplitMenuButtonWebElement);
